import React from 'react';
import CtSettingsTableTable from './table/CtSettingsTableTable';

const SettingsContent: React.FC = () => {
  return <CtSettingsTableTable />;
};

export default SettingsContent;
